export { default as defaultProfile } from "core/public/images/profile.png";
export { default as logoImg } from "core/public/images/bi.png";
export { default as scrollTopBtn } from "core/public/icon/btn_top@2x.png";
export { default as searchIcon } from "core/public/icon/search.png";
export { default as loading } from "core/public/icon/loading.gif";
